import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=68c73820&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"
import style0 from "./NoteItem.vue?vue&type=style&index=0&id=68c73820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c73820",
  null
  
)

export default component.exports